import type { ApplicationScope } from "@superblocksteam/shared";

export type Binding = {
  str: string;
  dataTreePath: `${ApplicationScope}.${string}`;
};

export enum TestDataType {
  EXTERNAL = "EXTERNAL",
  BLOCK_OUTPUT = "BLOCK_OUTPUT",
  VARIABLE = "VARIABLE",
}

export type StepRunTestData = Record<
  string,
  {
    value?: string | boolean | number;
    initialValue: string | boolean | number;
    type: TestDataType;
    isDirty: boolean;
  }
>;
